
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import PageBase from "../../../../../engines/modules/uiModule/PageBase";
import { OilFieldBuyPrams } from "../../../../../engines/modules/uiModule/UIPrams";
import getOneBundle, { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";
import { getKaoguItemConfig, getKaoguMountainConfig, KaoguMountainInfo } from "./config/kaoguMountainConfig";


const { ccclass, property } = cc._decorator;

@ccclass
export default class kaoguBuyPage extends PageBase {
    @property({ type: cc.Sprite, displayName: "矿山图片" })
    img_oilfield: cc.Sprite = null;
    @property({ type: cc.Label, displayName: "矿山名称" })
    lab_name: cc.Label = null;
    @property({ type: cc.Label, displayName: "矿山价格" })
    lab_price: cc.Label = null;
    @property({ type: cc.Label, displayName: "矿山内容" })
    lab_tips: cc.Label = null;

    @property({ type: cc.Node, displayName: "开采视频" })
    node_video: cc.Node = null;

    @property({type:cc.Node,displayName:"可获得列表"})
    getList:cc.Node=null;
    infoData: KaoguMountainInfo = null

    callBack: () => void = null;
    async OnPageOpen(prams?: OilFieldBuyPrams) {
        if (prams) {
            this.infoData = getKaoguMountainConfig[prams.id];
            this.lab_name.string = this.infoData.nickName;
            this.lab_price.string = `售价：${data_control.getNumberFormat(this.infoData.buyPrice)}`;
            this.lab_tips.string = this.infoData.tips;
            this.node_video.active = false// oilfieldDataHelp.getData().mineTimes > 0;
            this.callBack = prams.callBack;
            this.loadCangetList()
            console.warn("????prams",this.infoData)
            this.loadMoutainImg(prams.id)
        }
        super.OnPageOpen(prams)
    }

    async loadMoutainImg(id:number)
    {
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.kaogu , false);
        await new Promise<void>(resolve=>{
            bundle.load('res/kaogu/'+(id+1),cc.Texture2D,(e,ass:cc.Texture2D)=>{
                if(e)
                {
                    resolve();
                    return
                }
                const spriteFrame=new cc.SpriteFrame(ass);
                const maxSize=Math.max(spriteFrame.getOriginalSize().width,spriteFrame.getOriginalSize().height);
                this.img_oilfield.spriteFrame=spriteFrame;
                const realMax:number=300;
                const scale=realMax/maxSize;
                if(maxSize==spriteFrame.getOriginalSize().width)
                {
                    this.img_oilfield.node.width=realMax;
                    this.img_oilfield.node.height=spriteFrame.getOriginalSize().height*scale;
                }else
                {
                    this.img_oilfield.node.height=realMax;
                    this.img_oilfield.node.width=spriteFrame.getOriginalSize().width*scale;
                }
                resolve();
    
            })
        });
    }

    loadCangetList()
    {
        const list=this.infoData.insideIDList.concat(this.infoData.outsideIDList);
        const have:number[]=[];
        let index:number=0;
        console.warn('可获得列表',list)
        for(let i=0;i<list.length;i++)
        {
            if(!have.includes(list[i])&&list[i]!=0)
            {
                have.push(list[i]);
                const info=getKaoguItemConfig[list[i]];
                let node=this.getList.children[index];
                if(node==null)
                {
                    node=cc.instantiate(this.getList.children[0]);
                    this.getList.addChild(node);
                }
                this.loadImg(node.children[0].getComponent(cc.Sprite),info.spriteimg)
                index++;
            }

        }
    }

    async loadImg(sprite:cc.Sprite,url:string)
    {
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.kaogu, false );
        await new Promise<void>(resolve=>{
            bundle.load('res/kaogu/kaoguitem/'+url,cc.Texture2D,(e,ass:cc.Texture2D)=>{
                if(e)
                {
                    resolve();
                    return
                }
                const spriteFrame=new cc.SpriteFrame(ass);
                const maxSize=Math.max(spriteFrame.getOriginalSize().width,spriteFrame.getOriginalSize().height);
                sprite.spriteFrame=spriteFrame;
                const realMax:number=55;
                const scale=realMax/maxSize;
                if(maxSize==spriteFrame.getOriginalSize().width)
                {
                    sprite.node.width=realMax;
                    sprite.node.height=spriteFrame.getOriginalSize().height*scale;
                }else
                {
                    sprite.node.height=realMax;
                    sprite.node.width=spriteFrame.getOriginalSize().width*scale;
                }
                resolve();
            })
        });
    }

    clickTime: number = null;
    onClickMine() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        if (this.clickTime != null && new Date().getTime() - this.clickTime < 3000) return;
        this.clickTime = new Date().getTime()

        let func = () => {
            this.ClosePage();
            this.callBack && this.callBack();
        }
        if (this.node_video.active) {
            cc.game.pause();
            
            utilsModel.loadAndShowVideoAdTrans(async () => {
                cc.game.resume();
                func();
            }, () => {
                cc.game.resume();
            }, null, '看视频考古')
        } else func();
    }
}